import { DB_TYPE, OS_TYPE } from '@/common/define/common.define';

export const MAXGAUGE_MODE_FILTER_LIST = [
  'infra',
  'host',
  'database',
  'sms',
  'user',
  'log',
  'multi',
  ...Object.values(OS_TYPE),
  ...Object.values(DB_TYPE),
];
